
export default class IdlePoint {
    constructor (
        start,
        end,
        lat,
        lon,
        addressLabel,
        type
    ) {
        this.start = start
        this.end = end
        this.lat = lat
        this.lon = lon
        this.addressLabel = addressLabel
        this.type = type
    }
}
